
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSleepingNohdgcogSelectedIec as ObiAisTargetSleepingNohdgcogSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-sleeping-nohdgcog-selected-iec.js';
 
 
 

 
 export const ObiAisTargetSleepingNohdgcogSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-sleeping-nohdgcog-selected-iec',
   elementClass: ObiAisTargetSleepingNohdgcogSelectedIecElement,
   events: {
     
   }
  });
 
 